import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { FriendService } from './FriendService';
import { useTranslation } from 'react-i18next';

export default function NetworkIconButton({ currentUser, onOpen }) {
  const { t } = useTranslation();
  const [count, setCount] = React.useState(0);
  const meId = String(currentUser?.id || currentUser?._id || 'me');

  const refresh = React.useCallback(async () => {
    const API_BASE = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/+$/, '');
    const token = (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null) || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null);
    try {
      const res = await fetch(`${API_BASE}/friends/requests/pending`, { headers: token ? { 'Authorization': `Bearer ${token}` } : {} });
      if (res.ok) {
        const data = await res.json();
        const list = Array.isArray(data?.requests) ? data.requests : (Array.isArray(data) ? data : []);
        setCount(list.length);
      } else {
        const pending = FriendService.getPending(meId);
        setCount(pending.length);
      }
    } catch {
      const pending = FriendService.getPending(meId);
      setCount(pending.length);
    }
  }, [meId]);

  React.useEffect(() => {
    FriendService.seed(currentUser);
    refresh();
    const off = FriendService.onChange(() => refresh());
    const onRealtime = () => refresh();
    let timer = null;
    try { window.addEventListener('friends:changed', onRealtime); } catch {}
    try { timer = setInterval(() => refresh(), 15000); } catch {}
    return () => {
      off();
      if (timer) try { clearInterval(timer); } catch {}
      try { window.removeEventListener('friends:changed', onRealtime); } catch {}
    };
  }, [currentUser, refresh]);

  return (
    <Tooltip title={count > 0 ? t('header.friendConnections.badgeTooltip', '{{count}} pending requests', { count }) : t('header.friendConnections.openMyNetwork', 'My Network')}>
      <IconButton onClick={onOpen} sx={{ color: 'inherit' }} aria-label={t('header.friendConnections.openMyNetwork', 'My Network')}>
        <Badge color="error" badgeContent={count} invisible={count === 0} variant={count > 0 ? 'standard' : 'dot'}>
          <GroupIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
